const userLoginItems = document.querySelectorAll<HTMLElement>('.i-user-login');

const mobileQuery = window.matchMedia("(max-width: 61.999em)")
userLoginItems.forEach(userLogin => {
  const button = userLogin.querySelector<HTMLElement>('.i-user-login__button');
  const close = userLogin.querySelector<HTMLElement>('.i-user-login__close');

  button?.addEventListener('click', (e) => {
    if (!mobileQuery.matches) return;

    e.preventDefault();
    userLogin.classList.add('--open');
    document.body.classList.add('--disable-scroll');
  })

  close?.addEventListener('click', () => {
    if (!mobileQuery.matches) return;

    userLogin.classList.remove('--open');
    userLogin.blur();
    document.body.classList.remove('--disable-scroll');
  })
})
